import React from 'react';
import moment from 'moment';
import ReminderCellContent from './components/ReminderCellContent';

export function renderLate({ rowData }) {
  if (rowData.payment_date) {
    const dueDate = moment(rowData.payment_date, 'DD-MM-YYYY');
    return <span className="">{moment().diff(dueDate, 'days')}j</span>;
  }
}

export function renderReminder({ rowData }) {
  if (rowData.payment_date) {
    return <ReminderCellContent invoiceId={rowData.id} invoice={rowData} />;
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/invoices/workflow/toPay.js